import React from 'react';
import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router';

import Button from 'components/Button';

import {openModal} from 'ducks/modals';
import {MODALS} from 'ducks/oneOffChargeReasons';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<
  SubNavigationProps &
    RouteComponentProps<{locationRef: string}> &
    typeof mapDispatchToProps
> {
  openReasonCreateModal = () =>
    this.props.openModal(MODALS.CREATE_ONE_OFF_CHARGE_REASON);

  render() {
    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered">
        <Button white onClick={this.openReasonCreateModal}>
          Create charge reason
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = {
  openModal
};

export default withRouter(
  connect(null, mapDispatchToProps)(SubNavigation)
) as React.ComponentType<SubNavigationProps>;
